import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Schema stringa per valori monetari: marca lo schema con
     * `IsStringCurrencyMetaKey` e converte i valori numerici in stringa.
     */
    stringCurrency(): StringSchema;
  }
}

/**
 * Schema stringa per valori monetari: marca lo schema con
 * `IsStringCurrencyMetaKey` e converte i valori numerici in stringa.
 */
yup.addMethod(yup.string, 'stringCurrency', function () {
  return this.meta({ [IsStringCurrencyMetaKey]: true }).transform(value =>
    typeof value === 'number' ? String(value) : value,
  );
});

export const IsStringCurrencyMetaKey = 'isStringCurrency';

/**
 * Indica se lo schema è marcato come valuta-stringa (`stringCurrency`).
 */
export function isStringCurrencySchema(schema: yup.AnySchema): boolean {
  return Boolean(schema?.meta?.()?.[IsStringCurrencyMetaKey]);
}
